/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

// Default values for the Logs Page.
export const defaultShowSignificantLogs = true;
export const defaultShowNonSignificantLogs = false;
export const defaultPageNumber = 1;
export const defaultPageSize = 10;
